import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { login } from "../../../store/reducers/reducerUser";
import PanelFrame from "../../ui/PanelFrame";
import SiteButton from "../../ui/SiteButton";
import { useLang } from "../../../i18n/LangContext";

import "./signin.scss";

const SinIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useLang();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [formSend, setFormSend] = useState(false);
  const [loader, setLoader] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();

    if (!username && !password) {
      return toast.error("Please fill in all the fields please");
    }

    let data = { username, password };

    try {
      setFormSend(true);
      setLoader(true);

      dispatch(login(data)).then((response) => {
        const { error, payload } = response;

        if (error) {
          setFormSend(false);
          setLoader(false);
          if (
            typeof payload === "string" &&
            payload.toLowerCase().includes("banned")
          ) {
            return toast.error("This account is banned");
          }
          return toast.error("username or password is incorrect");
        }

        navigate("/profile");
      });
    } catch (error) {
      if (error) {
        setLoader(false);
        return (
          toast.error("something wrong please send again"), setFormSend(false)
        );
      }
    }
  }

  const classes = useStyles();
  return (
    <PanelFrame title={t("account_login")}>
      <Box id="containerSignIn">
        <Box
          id="subContainerSignIn"
          component="form"
          noValidate
          autoComplete="on"
          onSubmit={handleSubmit}
        >
          <TextField
            size="small"
            className={classes.root}
            sx={{ width: "100%", marginBottom: "10px !important" }}
            label={t("username")}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <TextField
            size="small"
            className={classes.root}
            sx={{ width: "100%" }}
            label={t("password")}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {loader ? (
            <CircularProgress sx={{ color: "white", marginTop: "10px" }} />
          ) : null}

          <SiteButton
            type="submit"
            variant="secondary"
            className="buttonSignIn"
            disabled={formSend}
          >
            {t("sign_in")}
          </SiteButton>
        </Box>
      </Box>
    </PanelFrame>
  );
};

const useStyles = makeStyles({
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiInputLabel-outlined": {
      color: "white",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "white",
    },
  },
});

export default SinIn;
